import React from "react";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarContent,
} from "react-pro-sidebar";
import { Link } from "react-router-dom";

import userDefaultPerfil from "../../images/perfil2.png";

import { useDispatch, useSelector } from "react-redux";
import { singOut } from "../../redux/auth/actions";
import { withRouter } from "react-router";

const SidebarEvaluacionDesempenio = (props) => {
  const dispatch = useDispatch();
  const userPic = useSelector((store) => store.auth.pic);
  const userN = useSelector((store) => store.auth.name);
  const userId = useSelector((store) => store.auth.id);
  const userType = useSelector((store) => store.auth.userType);

  const onSignOut = (e) => {
    e.preventDefault();
    dispatch(singOut(props));
  };
  return (
    <>
      <ProSidebar
        collapsed={false}
        className={`custom-sidebar ${props.show ? "show-sidebar" : ""}`}
        toggled={"fixed"}
      >
        <SidebarContent style={{ overflowY: "auto" }}>
          <Menu iconShape="square">
            <div className="d-block d-sm-block d-md-none">
              <SubMenu
                title={userN ? userN : null}
                icon={
                  <img
                    src={!!userPic ? userPic : userDefaultPerfil}
                    className="user-pic"
                    alt="Imagen de perfil"
                  />
                }
              >
                <MenuItem>
                  <Link to={`/perfil-usuario/${userId}/${userType}`}>
                    Mi perfil
                  </Link>
                </MenuItem>
                {/* <MenuItem><Link to="Dashboard-Headcount">Dashboard</Link></MenuItem> */}
                {/* <MenuItem style={{ borderBottom: "2px solid white" }}>
                  <Link to={`/perfil-usuario/${userId}`}>Mi perfil</Link>
                </MenuItem> */}
                <div className="row no-gutters"></div>
                <MenuItem
                  icon={<i className="material-icons">notifications</i>}
                >
                  <Link to="/#!">Notificaciones</Link>
                </MenuItem>
                <MenuItem onClick={onSignOut}>Cerrar sesión</MenuItem>
              </SubMenu>
            </div>
            <MenuItem icon={<i className="material-icons">face</i>}>
              <Link to={`/detalle-empleado/${userId}/${userType}`}>
                Ficha de empleado
              </Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">hourglass_top</i>}>
              <Link to="/evaluacion-desempenio/admin/periodoEvaluacion">
                Periodo evaluación
              </Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">pending_actions</i>}>
              <Link to="/evaluacion-desempenio/admin/planAccion">
                Plan de acción
              </Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">category</i>}>
              <Link to="/evaluacion-desempenio/admin/categoriaDesempenio">
                Categorias del desempeño
              </Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">create</i>}>
              <Link to="/evaluacion-desempenio/admin/tipo-evaluacion">
                Tipo evaluacion
              </Link>
            </MenuItem>
            <SubMenu
              title="Métricas"
              icon={<i className="material-icons">analytics</i>}
            >
              <MenuItem>
                <Link to="/evaluacion-desempenio/admin/métrica-por-factor">
                  Por factor
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to="/evaluacion-desempenio/admin/metricaCompetencia">
                  Por competencia
                </Link>
              </MenuItem>
            </SubMenu>
            <SubMenu
              title="Competencia"
              icon={<i className="material-icons">emoji_events</i>}
            >
              <MenuItem>
                <Link to="/evaluacion-desempenio/admin/pesoCompetencia">
                  Pesos
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to="/evaluacion-desempenio/admin/preguntas-por-competencia">
                  Preguntas de evaluación
                </Link>
              </MenuItem>
            </SubMenu>
            <SubMenu
              title="Factor"
              icon={<i className="material-icons">percent</i>}
            >
              <MenuItem>
                <Link to="/evaluacion-desempenio/admin/nombre-factor">
                  Nombres
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to="/evaluacion-desempenio/admin/factor">Pesos</Link>
              </MenuItem>
              <MenuItem>
                <Link to="/evaluacion-desempenio/admin/plantillas-por-periodo">
                  Preguntas de evaluación
                </Link>
              </MenuItem>
            </SubMenu>
            <MenuItem icon={<i className="material-icons">show_chart</i>}>
              <Link to="/evaluacion-desempenio/admin/periodicidad-de-aplicaciones-de-evaluaciones">
                Periodicidad
              </Link>
            </MenuItem>

            <SubMenu
              title="Evaluación por Objetivos"
              icon={<i className="material-icons">assignment</i>}
            >

              <MenuItem>
                <Link to="/evaluacion-desempenio/admin/tipo-formulario">
                  Tipo Formulario
                </Link>
              </MenuItem>

            
              <MenuItem>
                <Link to="/evaluacion-desempenio/admin/niveles">
                  Niveles
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to="/evaluacion-desempenio/admin/niveles-empleados">
                  Niveles Empleados
                </Link>
              </MenuItem>
            
              <MenuItem>
                <Link to="/evaluacion-desempenio/admin/conf-smart">
                  Configuración SMART
                </Link>
              </MenuItem>
                <MenuItem>
                <Link to="/evaluacion-desempenio/admin/pilar-estrategico">
                  Pilares Estratégicos
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to="/evaluacion-desempenio/admin/objetivos-competencias">
                  Competencias por objetivos
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to="/evaluacion-desempenio/admin/objetivos-valores">
                  Valores por Objetivos
                </Link>
              </MenuItem>
                <MenuItem>
                <Link to="/evaluacion-desempenio/admin/objetivos-metricas">
                  Métricas
                </Link>
              </MenuItem>
            </SubMenu>
            {/* <MenuItem icon={<i className="material-icons">list_alt</i>}>
              <Link to="/evaluacion-desempenio/admin/criterios-evaluador">
                Criterios de evaluador
              </Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">contacts</i>}>
              <Link to="/evaluacion-desempenio/admin/seleccion-colaboradores-evaluar">
                Selección de colaboradores
              </Link>
            </MenuItem> */}
          </Menu>
        </SidebarContent>
      </ProSidebar>
    </>
  );
};

export default withRouter(SidebarEvaluacionDesempenio);
